import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api, environment } from "../../environments/environment";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styles: [],
  standalone: false,
})
export class LoginComponent {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private translocoService: TranslocoService
  ) {}
  email: string = "";
  password: string = "";
  showPassword = false;
  manageCredentials(variableName: "email" | "password", value: any) {
    if (value?.value) {
      this[variableName] = value?.value;
    }
  }

  recoveryPassword() {
    this.router.navigate(["/recupero-password"]);
  }
  login() {
    this.loader.on();
    this.rest
      .post(api.endpoint.login, {
        email: this.email,
        password: this.password,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.rest.setToken(value.accessToken);
          // localStorage.setItem("refresh_token", value.refresh_token);
          localStorage.setItem("user", JSON.stringify(value.user));
          localStorage.setItem("roleId", value.role_id);
          if (value.role_id == 2 || value.role_id == 3) {
            this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate(['manager/profilo']);
              });
          } else {
            this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate(['manager/profilo']);
              });
          }
        },
        error: (value) => {
          this.loader.off(true);
          if (environment.testing) {
            this.rest.setToken("ciao");
            this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate(['manager/profilo']);
              });
          } else {
            this.message.showMessage(value.error.message, "error");
          }
        },
      });
  }

  registration() {
    this.router.navigate(["/registrazione"]);
  }
}
